module.exports = __webpack_public_path__ + "assets/ic_arrow_right6.e01f2dea.svg";